import styles from './FJAIImageList.module.less';
import FJMenuTab from '../../../components/FJMenuTab/FJMenuTab.jsx';
import FJSideModel from '../../../components/FJSideModel/FJSideModel.jsx';
import PropTypes from 'prop-types';
import { useRef, useState, useMemo } from 'react';
import FJSidePhotoListPanel from '../../../components/FJSidePhotoListPanel/FJSidePhotoListPanel.jsx';
import FJButton from '../../../components/FJButton/FJButton.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import FJHeaderConfig from '../../../../config/FJHeaderConfig.js';
import FJLocalStore from '../../../../store/FJLocalStore.js';

const FJAIImageList = props => {
    const {
        active,
        closeModal,
        aiTextToImageHistoryList,
        aiTextToImageHistoryLoadStatus,
        onTextToImageHistoryRetry,
        onImageToImageHistoryRetry,

        aiImageToImageHistoryList,
        aiImageToImageHistoryLoadStatus,

        itemClick,
    } = props;
    const menuTabList = useRef([{ text: 'text-to-image' }, { text: 'image-to-image' }]);
    const [curMenuIndex, setCurMenuIndex] = useState(0);
    const curLanguage = FJLocalStore.currentTag();

    const { tvImageList, tvImageListSize } = useMemo(() => {
        const tvImageList = [];
        const tvImageListSize = [];

        aiTextToImageHistoryList.forEach(item => {
            tvImageList.push({
                url: item.imgUrl,
                id: item.id,
            });
            tvImageListSize.push({
                width: 166,
                height: 166 / (item.width / item.height),
            });
        });

        return { tvImageList, tvImageListSize };
    }, [aiTextToImageHistoryList]);

    const { ivImageList, ivImageListSize } = useMemo(() => {
        const ivImageList = [];
        const ivImageListSize = [];

        aiImageToImageHistoryList.forEach(item => {
            ivImageList.push({
                url: item.imgUrl,
                id: item.id,
            });
            ivImageListSize.push({
                width: 166,
                height: 166 / (item.width / item.height),
            });
        });

        return { ivImageList, ivImageListSize };
    }, [aiImageToImageHistoryList]);

    const _itemClick = info => {
        itemClick(info, curMenuIndex);
    };

    const onGenerateClick = () => {
        closeModal();
        if (curMenuIndex === 0) {
            window.open(`${curLanguage === 'en' ? '' : '/' + curLanguage}${FJHeaderConfig.aiMenuList[3].href}`);
        } else if (curMenuIndex === 1) {
            window.open(`${curLanguage === 'en' ? '' : '/' + curLanguage}${FJHeaderConfig.aiMenuList[5].href}`);
        }
    };

    const renderBottom = () => {
        const isShow =
            (curMenuIndex === 0 && aiTextToImageHistoryLoadStatus === FJConstant.SUCCESS && tvImageList.length >= 1) ||
            (curMenuIndex === 1 && aiImageToImageHistoryLoadStatus === FJConstant.SUCCESS && ivImageList.length >= 1);
        if (!isShow) {
            return null;
        }
        return (
            <div className={styles.bottom}>
                <FJButton text='generate-now' type='gradient' className={styles.btn} onClick={onGenerateClick} />
            </div>
        );
    };

    return (
        <FJSideModel position={{ top: 148, left: 478 }} active={active} onClose={closeModal} className={styles.mask}>
            <div className={styles.content}>
                <FJMenuTab list={menuTabList.current} curIndex={curMenuIndex} onChange={setCurMenuIndex} />
                <div style={{ display: curMenuIndex === 0 ? 'block' : 'none' }}>
                    <FJSidePhotoListPanel
                        list={tvImageList}
                        sizeList={tvImageListSize}
                        status={aiTextToImageHistoryLoadStatus}
                        isShowBottom={false}
                        isTextToImageHistory={true}
                        onClickRetry={onTextToImageHistoryRetry}
                        itemClick={_itemClick}
                    />
                </div>
                <div style={{ display: curMenuIndex === 1 ? 'block' : 'none' }}>
                    <FJSidePhotoListPanel
                        list={ivImageList}
                        sizeList={ivImageListSize}
                        status={aiImageToImageHistoryLoadStatus}
                        isShowBottom={false}
                        isImageToImageHistory={true}
                        onClickRetry={onImageToImageHistoryRetry}
                        itemClick={_itemClick}
                    />
                </div>
            </div>
            {renderBottom()}
        </FJSideModel>
    );
};

FJAIImageList.propTypes = {
    active: PropTypes.bool,
    closeModal: PropTypes.func,
};
export default FJAIImageList;
